export default __webpack_public_path__ + "static/gamerize-2-b-00d20c598821bdc7d5266085ce063cef.webp";